<div class="page">
  <div class="page-content content">
    <app-content-faq [showSummary]="true"></app-content-faq>
  </div>
</div>
